import React from "react";
import { deleteMatchesByTournamentId } from "services/matchService";
import * as Sentry from "@sentry/react";

const DeleteMatchesButton = ({ tournament, onDeleted }) => {
  const handleDelete = async () => {
    const confirmed = window.confirm(
      "Êtes-vous sûr de vouloir supprimer tous les matchs de ce tournoi ? Cette action est irréversible."
    );

    if (!confirmed) return;

    try {
      await deleteMatchesByTournamentId(tournament?.id);
      onDeleted?.(); // trigger re-fetch
    } catch (error) {
      Sentry.captureException(error);

      console.error("Erreur lors de la suppression des matchs :", error);
      alert("❌ Une erreur est survenue pendant la suppression.");
    }
  };

  return (
    <button
      onClick={handleDelete}
      className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 font-bold ml-2"
    >
      Supprimer les matchs
    </button>
  );
};

export default DeleteMatchesButton;
